import React, { useContext } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import { lighten, withStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import LibraryPropertiesForm from "./LibraryPropertiesForm";
import { Box, Button, Typography } from "@material-ui/core";
import * as actions from "../actions/actions";
import NewProjectForm from '../components/NewProjectForm';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';

const backgroundBar = (percent, l) => {
  return (percent > 10) ? lighten("#BE0A00", l) : lighten("#017D01", l);
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: '100%',
    boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
    backgroundColor: "#ffffff",
  },
  result_box: {
    flex: "0 0 120",
    height: 120,
    padding: "0 10px",
    paddingBottom: "10px !important",
  },
  result_pending: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  expansion_block: {
    flex: "1 1 0",
    minHeight: 0,
    padding: "10px 10px 0px 10px",
    overflow: "hidden",
    overflowY: "auto",
  },

  linprog: {
    height: 40,
    marginTop: 8,
    backgroundImage: "url(/gfx/colorbar.png)",
  },
  bar: {
    backgroundImage: "url(/gfx/brushed-alum.png)",
    backgroundColor: (state) => {
      return backgroundBar(state.activeLibrary.ResultPercent, 0);
    },
    boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.5)",
  },

  content: {
    flex: "1 1 auto",
  },
  justify_content: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  alignText: {
    padding: "16px"

  },
  date_format: {
    padding: "0 !important",
  },
  progress_info: {
    textAlign: "center",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "100% 100%",
  },
  reportOverviewImage: {
    width: '100%',
    height: '20px',
    marginTop: 10,
    marginBottom: 5,
    imageRendering: "optimizeSpeed",             /* STOP SMOOTHING, GIVE ME SPEED  */
    // eslint-disable-next-line no-dupe-keys
    imageRendering: "-moz-crisp-edges",          /* Firefox                        */
    // eslint-disable-next-line no-dupe-keys
    imageRendering: "-o-crisp-edges",            /* Opera                          */
    // eslint-disable-next-line no-dupe-keys
    imageRendering: "-webkit-optimize-contrast", /* Chrome (and eventually Safari) */
    // eslint-disable-next-line no-dupe-keys
    imageRendering: "pixelated",                 /* Chrome */

  },
  percent_parent: {
    position: "relative",
  },
  percent_pos: {
    position: "absolute",
    top: -1,
    width: "100%",
    textAlign: "center",
    color: "white",
    fontWeight: "100",
    fontSize: 30,
    textShadow: "1px 1px 3px #555"
  },
  expansion_details: {
    padding: "0 !important",
  },
  pannelSummary: {
    padding: "0 16px",
  },
  plag_word: {
    color: "#f16b5b",
  },
  plag_block: {
    fontWeight: "500",
  },
  action_block: {
    textAlign: "center",
    paddingBottom: "10px"
  },
  update_padding: {
    padding: 0,
  },
  button_block: {
    width: '90%',
    margin: '0 5%'
  },
  selectReport: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: "1 1 auto",
    margin: theme.spacing(2),
    textAlign: "center",
  }

}));


const Accordion = withStyles({

  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    width: "100%",
    backgroundColor: '#ffffff',
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#F7F7F7",
    borderBottom: "1px solid #E6E6E6",
    marginBottom: -1,
    minHeight: 40,
    height: 40,
    "&$expanded": {
      minHeight: 40,
      height: 40,
      backgroundColor: "#E6E6E6",
    },
    '&:hover': {
      cursor: "pointer",
      backgroundColor: "#EEEEEE",
      transition: 'background-color 0.2s',
    },
  },

  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function LibraryData(props) {
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);
  const dispatch = useContext(DispatchContext);
  const [expanded, setExpanded] = React.useState("panel1");
  const { view } = props;

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  if (!state.activeLibraryId) {
    return (
      <div className={classes.root}>
        <div className={classes.selectReport}>
          <LibraryBooksIcon fontSize="large" color="primary" />
          <Box mt={3} />
          <Typography paragraph>{s.libraryOverview.selectLibrary}</Typography>
          <Typography variant="body2" color="primary">{s.libraryOverview.selectLibraryHint}</Typography>
        </div>
      </div>
    );
  }

  const magnifyMultipleRow = () => {
    let data = state.libraries.filter((item) => {
      return state.selectedLibraryIds.includes(item.Id);
    });
    dispatch(actions.setNewCheckSettings({ source: 'library', libraryTexts: data }));
    dispatch(actions.navigate_to('/plagiarism/new'));
    let sendData = {
      title: data[0].Name,
      author: data[0].Author,
      date: (data[0].Date && data[0].Date !== '0000-00-00 00:00:00') ? new Date(data[0].Date) : new Date(),
      projectid: data[0].ProjectId
    };
    dispatch(actions.setDraftReport(sendData));
  }

  return (
    <div className={classes.root}>
      {state.openCreateProjectPopup && <NewProjectForm />}
      <div className={classes.expansion_block}>
        {/* Properties Panel Start */}
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            className={classes.pannelSummary}
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            {s.properties}
          </AccordionSummary>
          <AccordionDetails className={classes.expansion_details}>
            {state.loadingLibraryDetail && <LibraryPropertiesForm className={classes.update_padding} library={state.activeLibrary} />}
          </AccordionDetails>
        </Accordion>
        {/* Properties Panel End */}

        {/* View Panel End */}
        {/* User Setting Panel End */}
        {/* Action Panel Start */}
        <Accordion
          square
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            className={classes.pannelSummary}
            aria-controls="panel4d-content"
            id="panel4d-header"
          >
            {s.actions}
          </AccordionSummary>
          <AccordionDetails className={classes.expansion_details}>
            <div style={{ width: '100%', paddingTop: '10px' }}>
              <div className={classes.action_block}>
                <Button className={classes.button_block} type="submit" variant="contained" color="primary" onClick={magnifyMultipleRow}>
                  {s.startPlagiarism}
                </Button>
              </div>
              {/* <div className={classes.action_block}>
                <Button className={classes.button_block} type="submit" variant="contained" color="primary">
                  {s.compareText}
                </Button>
              </div> */}
            </div>
          </AccordionDetails>
        </Accordion>
        {/* Action Panel End */}
      </div>
    </div>
  );
};
